import React, { useEffect, useState } from "react";
import {
  Building2,
  MapPin,
  Calendar,
  DollarSign,
  Bell,
  Briefcase,
  ArrowRight,
  IndianRupee,
} from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDefaultImage } from "../../shared-components/constants/constants";
import { postAnalysis } from "../../network/APIs/analysis";
import { Alert, Snackbar } from "@mui/material";
import { PaginationComponent } from "../../shared-components";

// Pagination constants
const ITEMS_PER_PAGE = 10;

// Mock Data for Alerts
// const MOCK_ALERTS = [
//   {
//     id: 1,
//     company: "TCS Digital",
//     title: "System Engineer - Digital Cadre",
//     location: "Pan India",
//     salary: "₹7.0 LPA",
//     type: "On Campus",
//     posted: "2 days ago",
//     logo: "https://logo.clearbit.com/tcs.com",
//     deadline: "Apply by 20 Oct",
//   },
//   {
//     id: 2,
//     company: "Infosys",
//     title: "Specialist Programmer (SP)",
//     location: "Bangalore / Pune",
//     salary: "₹9.5 LPA",
//     type: "Pool Campus",
//     posted: "Yesterday",
//     logo: "https://logo.clearbit.com/infosys.com",
//     deadline: "Apply by 18 Oct",
//   },
//   {
//     id: 3,
//     company: "Wipro Turbo",
//     title: "Project Engineer",
//     location: "Hyderabad",
//     salary: "₹6.5 LPA",
//     type: "On Campus",
//     posted: "Just now",
//     logo: "https://logo.clearbit.com/wipro.com",
//     deadline: "Apply by 22 Oct",
//   },
//   {
//     id: 4,
//     company: "Accenture",
//     title: "Associate Software Engineer",
//     location: "Gurgaon / Mumbai",
//     salary: "₹4.5 LPA",
//     type: "Off Campus Drive",
//     posted: "5 hours ago",
//     logo: "https://logo.clearbit.com/accenture.com",
//     deadline: "Apply by 25 Oct",
//   },
// ];

const CollegeAlertsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const [totalRecords, setTotalRecords] = useState(0);

  const userData = localStorage.getItem("Freshment_user_data");
  const userdetail = userData ? JSON.parse(userData) : null;

  useEffect(() => {
    if (userdetail === null) {
      navigate("/");
    }
  }, [userdetail, navigate]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        setError(null);

        let Freshment_user_data = localStorage.getItem("Freshment_user_data");
        Freshment_user_data = Freshment_user_data
          ? JSON.parse(Freshment_user_data)
          : null;

        const id = Freshment_user_data?.data?.id;
        const offset = (Number(page) - 1) * ITEMS_PER_PAGE;
        const URL = `https://govtjobsapi.governmentjobsforgraduates.com/api/v3/EduConnectPro/get_educonnectpro_trending_jobs?user_id=${id}&offset=${offset}&limit=${ITEMS_PER_PAGE}`;

        const response = await fetch(URL);

        if (!response.ok) {
          throw new Error(
            `Error fetching jobs: ${response.status} ${response.statusText}`,
          );
        }

        const data = await response.json();
        setJobs(data?.data ?? []);
        setTotalRecords(data?.totalRecords || data?.total_records || 0);
        // console.log("data", data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, [page]);

  const handlePageChange = ({ page }) => {
    searchParams.set("page", page + "");
    setSearchParams(searchParams);
  };

  const Analysis = ({ job_id, user_id, type, operation, link }) => {
    const isAuth = localStorage.getItem("Freshment_user_data");

    if (!isAuth) {
      return;
    }
    const Data = { job_id, user_id, type, operation };

    try {
      // console.log({ link });
      postAnalysis(Data);
      // console.log(Data);

      // console.log("like");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error performing analysis:", error);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleDismiss = (id) => {
    if (
      window.confirm("Dismiss this alert? It will be removed from your list.")
    ) {
      setJobs(jobs.filter((job) => job.id !== id));
    }
  };

  return (
    <>
      <div className="min-h-screen bg-slate-50/50 pt-8 pb-20 font-sans">
        <div className="max-w-4xl mx-auto px-8 xl:px-6 xsm:px-4">
          {/* Header */}
          <div className="flex items-center gap-5 mb-10">
            <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-indigo-500/30">
              <Bell className="w-7 h-7" />
            </div>
            <div>
              <h1 className="text-3xl font-black text-slate-900 tracking-tight">
                Campus Job Alerts
              </h1>
              <p className="text-slate-500 font-medium text-lg">
                Exclusive drives from your placement cell
              </p>
            </div>
          </div>

          {/* List */}
          <div className="space-y-5">
            {loading ? (
              <div className="text-center py-24 text-slate-400 font-semibold text-lg">
                Loading alerts...
              </div>
            ) : error ? (
              <div className="text-center py-24 text-red-500 font-semibold text-lg">
                {error}
              </div>
            ) : jobs.length > 0 ? (
              jobs.map((job) => (
                <div
                  key={job.id}
                  className="bg-white rounded-[1.5rem] p-6 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.05)] hover:border-indigo-100 transition-all duration-300 flex flex-row xsm:flex-col gap-6 items-start"
                >
                  {/* Logo */}
                  <div className="w-16 h-16 bg-white border border-slate-100 rounded-2xl flex items-center justify-center shadow-sm flex-shrink-0">
                    <img
                      src={getDefaultImage(job.job_category_id)}
                      alt={job.category_name}
                      className="w-full h-full object-contain"
                    />
                  </div>

                  {/* Details */}
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-3 mb-1">
                      <h3 className="text-xl font-bold text-slate-900">
                        {job.post_name}
                      </h3>
                      <span
                        className={`px-2.5 py-1 rounded-lg text-[11px] font-bold uppercase tracking-wide border ${job.job_type.includes("On Campus")
                          ? "bg-indigo-50 text-indigo-700 border-indigo-100"
                          : "bg-purple-50 text-purple-700 border-purple-100"
                          }`}
                      >
                        {job.job_type}
                      </span>
                    </div>

                    <div className="text-slate-600 font-bold mb-4 flex items-center gap-2 text-sm">
                      <Building2 className="w-4 h-4 text-slate-400" />{" "}
                      {job.company_name}
                    </div>

                    <div className="flex flex-wrap items-center gap-3 text-sm font-semibold">
                      {job.job_location && (
                        <div className="flex items-center gap-1.5 bg-slate-50 text-slate-600 px-3 py-1.5 rounded-lg border border-slate-100">
                          <MapPin className="w-3.5 h-3.5" /> {job.job_location}
                        </div>
                      )}
                      {job.salary && (
                        <div className="flex items-center gap-1.5 bg-emerald-50 text-emerald-700 px-3 py-1.5 rounded-lg border border-emerald-100">
                          <IndianRupee className="w-3.5 h-3.5" /> {job.salary}
                        </div>
                      )}
                      <div className="flex items-center gap-1.5 bg-amber-50 text-amber-700 px-3 py-1.5 rounded-lg border border-amber-100">
                        <Calendar className="w-3.5 h-3.5" /> Apply by{" "}
                        {job.application_end_date}
                      </div>
                    </div>
                  </div>

                  {/* Actions */}
                  {/* xsm:flex-row */}
                  <div className="flex flex-col gap-3 w-auto xsm:w-full mt-0 xsm:mt-2 pt-0 xsm:pt-4 border-0 xsm:border-t border-slate-100">
                    <button
                      onClick={() => {
                        navigate(`/job-description/${job.id}`);
                      }}
                      className="flex-none xsm:flex-1 flex items-center justify-center gap-2 px-6 py-2.5 bg-slate-900 text-white font-bold rounded-xl hover:bg-blue-600 transition shadow-lg shadow-slate-900/10 hover:shadow-blue-500/20 text-sm group"
                    >
                      View Details{" "}
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </button>

                    <div className="flex gap-2">
                      <button
                        onClick={() => {
                          Analysis({
                            job_id: job.id,
                            user_id: userdetail?.data?.id ?? null,
                            type: "like",
                            operation: "add",
                            link: "",
                          });
                        }}
                        className="flex-none xsm:flex-1 flex items-center justify-center px-4 py-2.5 bg-emerald-50 text-emerald-700 font-bold rounded-xl hover:bg-emerald-100 transition border border-emerald-100 text-sm"
                        title="I'm Interested"
                      >
                        Interested
                      </button>
                      <button
                        onClick={() => handleDismiss(job.id)}
                        className="flex-none xsm:flex-1 flex items-center justify-center px-4 py-2.5 bg-red-50 text-red-600 font-bold rounded-xl hover:bg-red-100 transition border border-red-100 text-sm"
                        title="Dismiss"
                      >
                        Dismiss
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-24 bg-white rounded-[2rem] border-2 border-dashed border-slate-200">
                <div className="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Briefcase className="w-10 h-10 text-slate-300" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  No New Alerts
                </h3>
                <p className="text-slate-500 font-medium">
                  You're all caught up! Check back later for new drives.
                </p>
              </div>
            )}
          </div>

          {jobs.length > 0 && (
            <div className="mt-12">
              <PaginationComponent
                totalRecords={totalRecords}
                itemsPerPage={ITEMS_PER_PAGE}
                handlePageChange={handlePageChange}
                setPageTo={Number(page) === 0 ? 1 : Number(page)}
              />
            </div>
          )}
        </div>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your interest in the job has been successfully recorded. Thank you!
        </Alert>
      </Snackbar>
    </>
  );
};

export default CollegeAlertsPage;
